module.exports = __webpack_public_path__ + "static/longlogo@4x-c7f0cc0931607938ebd2a35a61e3edfd.png";